import { calculateOrgPermissions } from '../../../../../backend/features/accounts/shared';
import { transformOrgColumnIntoDataObject } from '../../../../../backend/features/accounts/utils/transformOrgColumnIntoDataObject';
import { flatten } from '../../../../../backend/utils/FilterUtils';
import { filterAccountColumnsOrganizationsByPermission, getDefaultOrgRole, } from '../../shared';
export function handleOrganizationMemberRoleAndStatus({ appContext, secureBulkActionParams: { createdBy, data, isCancelled, updateProcessedCount }, row, accountStorage, actionOwner, processedIndex, }) {
    const defaultOrgRole = getDefaultOrgRole(appContext.appState.settings.orgRoleMap);
    if (!defaultOrgRole) {
        throw new Error('No default organization role set. Please check settings orgRoleMap and set default role.');
    }
    const { organizationId, newStatus, newRole } = data.params;
    const currentAccountOrgRoles = transformOrgColumnIntoDataObject(row.columns.orgRole);
    const currentOrgStatuses = transformOrgColumnIntoDataObject(row.columns.orgStatus);
    const ownerSystemPermissions = appContext.appState.settings.systemRoleMap[actionOwner.data.systemRole].permissions;
    const { orgStatus: allowedToManageOrgStatuses, orgRole: allowedToManageOrgRoles } = filterAccountColumnsOrganizationsByPermission(row.columns, row.id, ['manage-members'], {
        id: createdBy,
        orgPermissions: calculateOrgPermissions(appContext, actionOwner.data),
        systemPermissions: ownerSystemPermissions,
    });
    const currentOrgStatus = allowedToManageOrgStatuses[organizationId];
    const currentOrgRole = allowedToManageOrgRoles[organizationId];
    // Check if role is required for this orgStatus
    const { updatedRoles, updatedStatuses, isDeleted } = handleChangeRoleAndStatus({
        currentAccountOrgRoles,
        currentOrgStatuses,
        organizationId,
        secureFilter: data.secureParams.secureFilter,
        orgStatusMap: appContext.appState.settings.orgStatusMap,
        newRole,
        newStatus,
        defaultOrgRole,
        currentOrgStatus,
        currentOrgRole,
    });
    if (allowedToManageOrgStatuses[organizationId] && (updatedRoles || updatedStatuses)) {
        accountStorage.post({
            action: 'partial-update',
            id: row.id,
            data: {
                orgRole: updatedRoles !== null && updatedRoles !== void 0 ? updatedRoles : currentAccountOrgRoles,
                orgStatus: updatedStatuses !== null && updatedStatuses !== void 0 ? updatedStatuses : currentOrgStatuses,
            },
        });
    }
    updateProcessedCount(processedIndex + 1);
    return { cancel: isCancelled(), deleted: isDeleted };
}
function handleChangeRoleAndStatus({ currentAccountOrgRoles, currentOrgStatuses, organizationId, secureFilter, orgStatusMap, newRole, newStatus, defaultOrgRole, currentOrgStatus, currentOrgRole, }) {
    var _a, _b, _c;
    let roles;
    const statuses = Object.assign({}, currentOrgStatuses);
    // const checkMustHaveRoleStatus = newStatus;
    const mustHaveRole = newStatus ? !!((_a = orgStatusMap === null || orgStatusMap === void 0 ? void 0 : orgStatusMap[newStatus]) === null || _a === void 0 ? void 0 : _a.requireOrgRole) : false;
    if (newStatus) {
        statuses[organizationId] = newStatus;
    }
    else {
        delete statuses[organizationId];
    }
    if (!mustHaveRole && !newStatus) {
        roles = Object.assign({}, currentAccountOrgRoles);
        delete roles[organizationId];
    }
    else if (mustHaveRole && !newStatus && defaultOrgRole) {
        roles = Object.assign(Object.assign({}, currentAccountOrgRoles), { [organizationId]: (_b = newRole !== null && newRole !== void 0 ? newRole : currentOrgRole) !== null && _b !== void 0 ? _b : defaultOrgRole });
    }
    else if (newStatus) {
        if (mustHaveRole && defaultOrgRole) {
            roles = Object.assign(Object.assign({}, currentAccountOrgRoles), { [organizationId]: (_c = newRole !== null && newRole !== void 0 ? newRole : currentOrgRole) !== null && _c !== void 0 ? _c : defaultOrgRole });
        }
        else if (!mustHaveRole) {
            roles = Object.assign({}, currentAccountOrgRoles);
            delete roles[organizationId];
        }
    }
    const flatFilter = flatten(secureFilter);
    const orgStatusValues = new Set();
    for (const filter of flatFilter) {
        if ('column' in filter && 'metadata' in filter && filter.column === 'orgStatus') {
            if (filter.metadata && 'ui' in filter.metadata) {
                if (filter.metadata.ui && typeof filter.metadata.ui === 'object' && 'orgStatusInStaticOrg' in filter.metadata.ui) {
                    if (Array.isArray(filter.metadata.ui.orgStatusInStaticOrg)) {
                        filter.metadata.ui.orgStatusInStaticOrg.forEach((status) => orgStatusValues.add(status));
                    }
                    else if (typeof filter.metadata.ui.orgStatusInStaticOrg === 'string') {
                        orgStatusValues.add(filter.metadata.ui.orgStatusInStaticOrg);
                    }
                }
            }
        }
    }
    const isDeleted = currentOrgStatus
        ? orgStatusValues.has(`${organizationId}_${currentOrgStatus}`) && !orgStatusValues.has(`${organizationId}_${newStatus}`)
        : false;
    return { updatedRoles: roles, updatedStatuses: statuses, isDeleted };
}
